{
	"send": "Enviar"
}
